import { Component, OnInit } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { FormlyHelper } from "../../../helpers/formly-helper";
import { Validators } from "@angular/forms";
import { StepBasedOnSelectboxOptions } from "../../../enumerations/step-based-on.enum";

@Component({
  selector: "formly-datetime-local",
  templateUrl: "./formly-datetime-local.component.html",
  styleUrls: ["./formly-datetime-local.component.css"]
})
export class FormlyDatetimeLocalComponent extends FieldType implements OnInit {
  public submitted: boolean;
  constructor(public formlyHelper: FormlyHelper) {
    super();
  }

  public ngOnInit() {
    this.formlyHelper.getGeneralFormSubmission$()
      .subscribe(res => this.submitted = true);
    if (this.field.templateOptions.required) {
      this.formControl.setValidators(Validators.required);
    }
  }

  public stepDeadlineSupportedDatesFields: string[] = [
    "ClosingAMS",
    "ClosingDocument",
    "ClosingIMO",
    "ClosingReefer",
    "ClosingVessel",
    "ClosingVGM",
    "Demurrage",
    "Detention",
    "Storage"];

  public createStepWithDeadline() {

    if (this.isFormControlDisabled) {
      return;
    }

    let basedOn = StepBasedOnSelectboxOptions.OperationalFileDate;

    switch (this.field?.key) {
      case "Detention":
        basedOn = StepBasedOnSelectboxOptions.Detention;
        break;
      case "Demurrage":
        basedOn = StepBasedOnSelectboxOptions.Demurrage;
        break;
      case "Storage":
        basedOn = StepBasedOnSelectboxOptions.Storage;
        break;
      case "ClosingVessel":
        basedOn = StepBasedOnSelectboxOptions.ClosingVesselDate;
        break;
      case "ClosingAMS":
        basedOn = StepBasedOnSelectboxOptions.ClosingAMS;
        break;
      case "ClosingDocument":
        basedOn = StepBasedOnSelectboxOptions.ClosingDocument;
        break;
      case "ClosingIMO":
        basedOn = StepBasedOnSelectboxOptions.ClosingIMO;
        break;
      case "ClosingReefer":
        basedOn = StepBasedOnSelectboxOptions.ClosingReefer;
        break;
      case "ClosingVGM":
        basedOn = StepBasedOnSelectboxOptions.ClosingVGM;
        break;
    }
    this.formlyHelper.createStepWithDeadline(basedOn);
  }

  public get isFormControlDisabled() {
    return this.formControl.disabled
  }
}
